import { apiAction } from '@store/middlewares/api/ApiActionCreators';
import { ENDPOINT_DOCUMENTS_GET_UPLOAD_SIGNED_URL, ENDPOINT_DOCUMENTS_META_DATA } from '@utilities/apiConstants';
import ApiRestMethod from '@utilities/apiEndpoints/ApiRestMethod';
import ApiService from '@utilities/apiEndpoints/ApiService';
import {
	GET_DOCUMENT_UPLOAD_SIGNED_URL,
	GET_DOCUMENT_BY_SIGNED_URL,
	GET_DOCUMENTS_META_DATA,
	UPLOAD_DOCUMENT_SIGNED_URL
} from '@store/actions/types';
import {
	DocumentsMetaDataPayload,
	GetDocumentBySignedUrlActionParams,
} from '@data/documentSignedUrl/types/DocumentsMetaDataRequest';
import { ApiActionPayload } from '@interfaces/ApiAction/ApiActionPayload';
import {
	GetUploadSignedUrlRequest,
	GetUploadSignedUrlResponse
} from '@data/documentSignedUrl/types/DocumentUploadSignedUrl.types';
import { ErrorStatusState } from '@interfaces/ErrorStatus/ErrorStatusState';
import { PDF_CONTENT_TYPE, DOCUMENT_SIGNED_URL_IDENTIFIER } from '@utilities/constants';

export const getDocumentsMetaDataAction = (
	requestOverride: DocumentsMetaDataPayload,
) => {
	return apiAction({
		url: ENDPOINT_DOCUMENTS_META_DATA,
		method: ApiRestMethod.POST,
		apiService: ApiService.DS,
		includeAccessToken: true,
		label: GET_DOCUMENTS_META_DATA,
		shouldDisableLoadIndicator: true,
		...requestOverride,
	});
};

export const getDocumentBySignedUrlAction = ({
	id,
	identifier,
	signedUrl,
	...requestOverride
}: GetDocumentBySignedUrlActionParams) => {
	return apiAction<unknown, ErrorStatusState, Blob>({
		method: ApiRestMethod.GET,
		url: signedUrl,
		label: GET_DOCUMENT_BY_SIGNED_URL,
		responseType: 'blob',
		headers: {
			'apikey': undefined,
			'x-goog-meta-docid': id,
			'x-goog-meta-identifier': identifier,
		},
		...requestOverride,
	});
};

export const getSignedUrlForUploadAction = (overrides: Partial<ApiActionPayload<GetUploadSignedUrlRequest, ErrorStatusState, GetUploadSignedUrlResponse>> = {}) => {
	return apiAction<GetUploadSignedUrlRequest, ErrorStatusState, GetUploadSignedUrlResponse>({
		apiService: ApiService.DS,
		method: ApiRestMethod.POST,
		url: ENDPOINT_DOCUMENTS_GET_UPLOAD_SIGNED_URL,
		label: GET_DOCUMENT_UPLOAD_SIGNED_URL,
		includeAccessToken: true,
		...overrides,
	});
};

export const uploadDocumentSignedUrlAction = (signedUrl: string, file: Blob, documentId: string, overrides: Partial<ApiActionPayload> = {}) => {
	return apiAction({
		method: ApiRestMethod.PUT,
		url: signedUrl,
		label: UPLOAD_DOCUMENT_SIGNED_URL,
		headers: {
			'apikey': undefined,
			'Content-Type': PDF_CONTENT_TYPE,
			'x-goog-meta-docId': documentId,
			'x-goog-meta-identifier': DOCUMENT_SIGNED_URL_IDENTIFIER,
		},
		data: file,
		...overrides,
	});
};
